import React from "react";
import { ArrowUp } from "lucide-react";
import {useNavigate} from "react-router-dom";

const Footer = () => {

    const navigate = useNavigate();

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <footer className="bg-[#0c1248] text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Main Footer Content */}
                <div className="py-12">
                    <div className="grid md:grid-cols-2 gap-8">
                        {/* Company Info */}
                        <div className="space-y-4">
                            <div className="flex items-center">
                                <div className="bg-white rounded-lg p-2 mr-3">
                                    <img
                                        src={require('../../assets/m4m-logo.png')}
                                        alt="Manage4Me Logo"
                                        className="h-6 w-6"
                                    />
                                </div>
                                <a className="text-xl font-bold" href="https://apps.manage4me.org/">Manage4Me</a>
                            </div>
                            <p className="text-gray-300 leading-relaxed">
                                Com a tecnologia que resolve para você. Soluções completas de gestão
                                e organização para impulsionar seu negócio.
                            </p>

                            {/* Social Media Links */}
                            <div className="flex space-x-4">
                                <a
                                    href="#facebook"
                                    className="group w-10 h-10 bg-gray-700 hover:bg-[#d03737] rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                                >
                                    <svg className="w-5 h-5 text-gray-300 group-hover:text-white transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                    </svg>
                                </a>

                                <a
                                    href="#instagram"
                                    className="group w-10 h-10 bg-gray-700 hover:bg-[#d03737] rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                                >
                                    <svg className="w-5 h-5 text-gray-300 group-hover:text-white transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                                    </svg>
                                </a>

                                <a
                                    href="#twitter"
                                    className="group w-10 h-10 bg-gray-700 hover:bg-[#d03737] rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                                >
                                    <svg className="w-5 h-5 text-gray-300 group-hover:text-white transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                                    </svg>
                                </a>
                            </div>
                        </div>

                        {/* Links */}
                        <div className="space-y-4">
                            <h3 className="text-lg font-semibold">Links Importantes</h3>
                            <div className="space-y-2">
                                <a
                                    href="#empresa"
                                    className="block text-gray-300 hover:text-[#d03737] transition-colors duration-200"
                                >
                                    A Empresa
                                </a>
                                <a
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                        navigate('/termsAndServices');
                                    }}
                                    className="block text-gray-300 hover:text-[#d03737] transition-colors duration-200"
                                >
                                    Termos e Serviços
                                </a>
                                <a
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                        navigate('/privacyPolicy');
                                    }}
                                    className="block text-gray-300 hover:text-[#d03737] transition-colors duration-200"
                                >
                                    Política de Privacidade
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Footer */}
                <div className="border-t border-gray-700 py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-gray-400 text-sm">
                            © 2024 Manage4Me. Todos os direitos reservados.
                        </p>

                        {/* Back to Top Button */}
                        <button
                            onClick={scrollToTop}
                            className="mt-4 md:mt-0 inline-flex items-center px-4 py-2 bg-[#d03737] hover:bg-[#d03737]/80 rounded-lg transition-colors duration-200 group"
                        >
                            <span className="text-sm font-medium mr-2">Voltar ao topo</span>
                            <ArrowUp className="w-4 h-4 group-hover:-translate-y-1 transition-transform duration-200" />
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;